import { tns } from "tiny-slider/src/tiny-slider";

// Sliders via Tiny-Slider
class Sliders {
    
    constructor() {

        // Store all sliders on page so they can be accessed
        this.pageSliders = {};
        // converts Nodelist into an Array for looping
        let sliders = Array.prototype.slice.call(document.querySelectorAll('.slider'));

        if (sliders.length > 0) {
            // Set gallery image caption & slide index
            function setSliderContent(info, footer) {
                const idxCurrent = info.index;
                const idxImage = info.slideItems[idxCurrent].querySelector('img');
                footer.querySelector('.slider-caption').innerText = idxImage.alt;
                footer.querySelector('.slider-position').innerText = `${idxCurrent + 1}/${info.slideCount}`;
            }
    
            for (let item of sliders) {
                const id = item.dataset.sliderId;
                /** 
                 *  Get inline options for TinySlider from data attribute: 
                 *  https://github.com/ganlanyuan/tiny-slider
                 *  data-options='{"controls": true, "nav": false, "loop": false }"
                 *  -- TIP: for JSON to be valid from twig output must have full quotes on key { "key":value }
                 */
                const inlineOptions = JSON.parse(item.dataset.options);
                // Slider Navigation Element
                const nav = item.querySelector('.slider-nav');
                // Slider Footer Element
                const footer = item.querySelector('.slider-footer');
                // settings
                const settings = {
                    container: item.querySelector('.slider-items'),
                    prevButton: nav.querySelector('.slider-nav-prev'),
                    nextButton: nav.querySelector('.slider-nav-next')
                };
                // inline options
                const options = Object.assign(settings, inlineOptions);
                // TinySlider Init
                const slider = tns(options);

                this.pageSliders[id] = slider;
    
                // If the slider has a footer update footer content on transitionEnd
                if( footer !== null ) {
                    // initial set
                    const info = slider.getInfo();
                    setSliderContent(info, footer);
                    // Set content on transitionend
                    slider.events.on('transitionEnd', (info) => {
                        setSliderContent(info, footer);
                    });
                    // set content on indexChanged
                    slider.events.on('indexChanged', (info) => {
                        setSliderContent(info, footer);
                    });
                }
            }
        }
    }
}

export { Sliders };